import React from 'react'
import Select, { createFilter } from 'react-select'
import { strings } from '../../localization/strings'

class Component extends React.Component {
    mapOption = (option) => {
        const valueTag = !this.props.valueTag ? 'value' : this.props.valueTag
        const labelTag = !this.props.labelTag ? 'label' : this.props.labelTag
        return !option
            ? null
            : { ...option, value: option[valueTag], label: option[labelTag] }
    }

    render() {
        const selectedOption = this.mapOption(this.props.selectedOption)
        const options =
            !this.props.options || !this.props.options.length
                ? []
                : this.props.options.map((x) => this.mapOption(x))

        return (
            <div style={this.props.style}>
                <span
                    style={{
                        fontSize: '75%',
                        fontFamily: 'neutra',
                        lineHeight: 1,
                        color: this.props.error ? '#f44336' : undefined,
                        opacity: this.props.disabled ? 0.38 : undefined,
                    }}
                >
                    {this.props.label}
                </span>
                <Select
                    styles={{
                        container: (provided) => {
                            return { ...provided, paddingTop: '10px' }
                        },
                        menu: (provided) => {
                            if (this.props.openUp) {
                                return {
                                    ...provided,
                                    top: 'auto',
                                    bottom: '100%',
                                }
                            }
                            return { ...provided }
                        },
                        control: (base) => ({
                            ...base,
                            height: this.props.inputHeight,
                            alignItems: 'stretch',
                        }),
                    }}
                    placeholder={strings.selectSimplePlaceholder}
                    noOptionsMessage={({ inputValue: string }) =>
                        strings.selectSimpleNoOptionsMessage + string
                    }
                    options={options}
                    value={selectedOption}
                    onChange={(x) => this.props.handleChange(x)}
                    isDisabled={this.props.disabled}
                    filterOption={
                        !this.props.labelForFilter
                            ? undefined
                            : createFilter({
                                  stringify: (option) =>
                                      `${
                                          option.data[this.props.labelForFilter]
                                      }`,
                              })
                    }
                />
            </div>
        )
    }
}

export default Component
